import { render, staticRenderFns } from "./SuggestClient.vue?vue&type=template&id=6e6622ae&"
import script from "./SuggestClient.vue?vue&type=script&lang=js&"
export * from "./SuggestClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports